import {Component, OnInit} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ScriptLoaderService} from "../services/script-loader.service";
import {Conf} from "../settings/config";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {User} from "../models/user.model";
import {AuthServices} from "../services/auth.service";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-tour-review',
  templateUrl: './tour-review.component.html'
})
export class TourReviewComponent implements OnInit {


  reviewForm: FormGroup;
  reviewImages: Array<any>;
  files: FileList;
  auth_user = new User();
  slug;
  tour;

  constructor(private route: ActivatedRoute, private router: Router, private fb: FormBuilder, private _script: ScriptLoaderService, private http: HttpClient, private authService: AuthServices) {

    this.reviewForm = fb.group({
      'rating': [null, [Validators.required]],
      'title': [null, [Validators.required]],
      'review': [null, [Validators.required]],
      'year': ['', [Validators.required]],
      'month': ['', [Validators.required]],
      'sort': [null, [Validators.required]],
      'tour_guide': [null, [Validators.required]],
      'tour_operation': [null, [Validators.required]],
      'accommodation': [null],
      'meals': [null],
      'transportation': [null, [Validators.required]],
      'money': [null, [Validators.required]],
      'confirmed': [true, [Validators.requiredTrue]],
    });
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.slug = params['slug'];

      this.http.get(Conf.API_URL + '/tour/?slug=' + this.slug).subscribe(
          data => {
            this.tour = data['results'][0];
          },
          error => {
            console.log(error.error)
          }
      );

      this.reviewImages = [];
      const self = this;

      $(".star-rating").on('rating:change', function (event, value) {
        const name = $(this).attr('id');
        self.reviewForm.get(name).setValue(value);
      });

      this.authService.currentUser.subscribe((user: User) => {
        this.auth_user = user;
      });
    })

  }

  removeImage(index) {
    this.reviewImages.splice(index, 1);
    if (this.reviewImages.length === 0) {
      // this.projectForm.controls['image'].setValue(null);
    }
  }

  onAddPhoto(event) {
    const self = this;
    this.files = event.target.files;

    for (let i = 0, f; f = this.files[i]; i++) {
      if (!f.type.match('image.*')) {
        // this.toasterService.pop('error', '', 'The picture must be a file of type: jpeg, jpg, png!');
        continue;
      }
      const reader = new FileReader();
      reader.onload = (function (file) {
        return function (e) {

          file['style'] = {'background-image': `url(${e.target.result})`};
          file['image'] = e.target.result;
          self.reviewImages.push(file);

          (<HTMLInputElement>document.getElementById('photos')).value = null;
        };
      })(f);
      reader.readAsDataURL(f);
    }
  }

  clickReview() {
    this.reviewForm['isSubmitted'] = true;

    if (this.reviewForm.valid) {
      const headers = new HttpHeaders({'Authorization': `Token ${this.auth_user.token}`});

      this.http.post(Conf.API_URL + '/tour-reviews/', {
        tour: this.tour.id,
        user: this.auth_user.id,
        rating: this.reviewForm.value.rating,
        title: this.reviewForm.value.title,
        review: this.reviewForm.value.review,
        date: this.reviewForm.value.year + '-' + this.reviewForm.value.month + '-01',
        transportation: this.reviewForm.value.transportation,
        tour_guide: this.reviewForm.value.tour_guide,
        meals: this.reviewForm.value.meals,
        tour_operation: this.reviewForm.value.tour_operation,
        accommodation: this.reviewForm.value.accommodation,
        money: this.reviewForm.value.money,
        sort: this.reviewForm.value.sort,
        images: this.reviewImages
      }, {
        headers: headers
      }).subscribe(
          data => {
            this.router.navigate(['/things-to-do/tours-and-activities', this.tour.slug]);
          },
          error => {
            console.log(error.error)
          }
      );
    }
  }


}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/tour-review/tour-review.component.ts